// src/pages/ValidarTicket.js
// Se abre cuando el invitado escanea su QR con la cámara del celu.
// NO es para el personal de puerta — esa validación la hace QrScanner.
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const API = "https://mocaub1h8d.execute-api.us-east-1.amazonaws.com/prod";

const GENDER_LABEL = { M: "Masculino", F: "Femenino", Otro: "Otro" };

export default function ValidarTicket() {
  const { inscripcionId } = useParams();
  const [state, setState] = useState("loading"); // loading | valid | used | invalid
  const [data, setData]   = useState(null);

  useEffect(() => {
    if (!inscripcionId) return setState("invalid");

    axios
      .post(`${API}/getInscripcionInfo`, { inscripcionId })
      .then((res) => {
        const item = res.data?.Item || res.data;
        if (!item || !item.inscripcionId) return setState("invalid");
        setData(item);
        if (item.status === "INGRESADO") setState("used");
        else if (item.status === "APROBADO") setState("valid");
        else setState("invalid");
      })
      .catch(() => setState("invalid"));
  }, [inscripcionId]);

  if (state === "loading") {
    return (
      <div style={styles.page("#1a1a1a")}>
        <div style={styles.spinner} />
        <p style={{ color: "#dfa66b", marginTop: 20 }}>Verificando ticket...</p>
      </div>
    );
  }

  if (state === "valid") {
    return (
      <div style={styles.page("#0a3d1f")}>
        <div style={styles.icon}>✅</div>
        <h2 style={styles.title("#d1e7dd")}>Ticket válido</h2>
        <div style={styles.card}>
          <Row label="Nombre"     value={`${data.first_name} ${data.last_name}`} />
          <Row label="DNI"        value={data.dni} />
          <Row label="Email"      value={data.email} />
          <Row label="WhatsApp"   value={data.whatsapp} />
          <Row label="Sexo"       value={GENDER_LABEL[data.gender] || data.gender} />
          <Row label="Nacimiento" value={data.birth_date} />
          <Row label="Estado"     value="APROBADO ✓" highlight />
        </div>
        <p style={styles.note}>Este QR es personal e intransferible.</p>
      </div>
    );
  }

  if (state === "used") {
    return (
      <div style={styles.page("#3d0a0a")}>
        <div style={styles.icon}>❌</div>
        <h2 style={styles.title("#f8d7da")}>QR ya utilizado</h2>
        {data && (
          <div style={styles.card}>
            <Row label="Nombre" value={`${data.first_name} ${data.last_name}`} />
            <Row label="DNI"    value={data.dni} />
            <Row label="Ingresó" value={data.ingresado_at?.slice(0, 16).replace("T", " ") || "—"} />
          </div>
        )}
        <p style={styles.note}>Este ticket ya fue escaneado en la entrada.</p>
      </div>
    );
  }

  return (
    <div style={styles.page("#3d2a0a")}>
      <div style={styles.icon}>⚠️</div>
      <h2 style={styles.title("#fff3cd")}>Ticket no válido</h2>
      <p style={{ color: "#fff3cd", textAlign: "center", fontSize: 14, padding: "0 24px" }}>
        Este QR no corresponde a una entrada aprobada o no existe.
      </p>
    </div>
  );
}

function Row({ label, value, highlight }) {
  return (
    <div style={styles.row}>
      <span style={styles.rowLabel}>{label}</span>
      <span style={{ ...styles.rowValue, color: highlight ? "#198754" : "#111", fontWeight: highlight ? "700" : "500" }}>
        {value}
      </span>
    </div>
  );
}

const styles = {
  page: (bg) => ({
    background: bg,
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: 24,
  }),
  icon:  { fontSize: 64, marginBottom: 12 },
  title: (color) => ({ color, margin: "0 0 20px", fontSize: 22, textAlign: "center" }),
  card:  {
    background: "#fff",
    borderRadius: 14,
    padding: "16px 20px",
    width: "100%",
    maxWidth: 380,
    boxShadow: "0 4px 16px rgba(0,0,0,0.3)",
  },
  row:      { display: "flex", justifyContent: "space-between", padding: "10px 0", borderBottom: "1px solid #f0f0f0" },
  rowLabel: { color: "#888", fontSize: 13 },
  rowValue: { fontSize: 14, textAlign: "right", maxWidth: "60%" },
  note:     { color: "rgba(255,255,255,0.5)", fontSize: 12, marginTop: 16, textAlign: "center" },
  spinner:  {
    width: 48, height: 48, border: "4px solid #333",
    borderTop: "4px solid #dfa66b", borderRadius: "50%",
    animation: "spin 1s linear infinite",
  },
};
